import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, InputGroup } from 'reactstrap';

import MessageBox from 'Components/Utility/MessageBox';
import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import { doActualPasswordReset } from 'Redux/ducks/auth';

const messages = defineMessages({
  title: {
    id: 'password-reset.title',
    defaultMessage: 'Password Reset',
  },
});

const PasswordReset = ({
  match,
}) => {
  const dispatch = useDispatch();
  const passwordReset = useSelector(state => state.password_reset);
  const { token } = match.params;
  const [formState, setFormState] = useState({
    reg_password: '',
    reg_confirm: '',
    passwordLengthError: '',
    confirmPasswordError: '',
  });

  const { formatMessage } = useIntl();

  const {
    confirmPasswordError,
    passwordLengthError,
    reg_password: password,
    reg_confirm: confirmPassword,
  } = formState;

  const handleSubmit = (e) => {
    e.preventDefault();
    let isValid = true;

    if (password !== confirmPassword) {
      setFormState(prevState => ({
        ...prevState,
        confirmPasswordError: 'Password\'s do not match',
      }));

      isValid = false;
    }

    if (password.length < 6) {
      setFormState(prevState => ({
        ...prevState,
        passwordLengthError: 'Password must be 6 characters or more',
      }));
      isValid = false;
    }

    if (!isValid) return false;

    dispatch(doActualPasswordReset(token, password));
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState(prevState => ({
      ...prevState,
      [name]: value,
      passwordLengthError: '',
      confirmPasswordError: '',
    }));
  };

  return (
    <React.Fragment>
      <Meta brandTitle title={formatMessage(messages.title)} />
      <NoIndex />
      <div className="fanatical-general-page">
        <div className="container">
          <div className="fanatical-general-page-content">
            <h1>
              <FormattedMessage id="password-reset.reset.title" defaultMessage="Password Reset" />
            </h1>
            <hr />
            {passwordReset?.status !== 99 &&
            <React.Fragment>
              <p>
                <FormattedMessage id="password-reset.new-password" defaultMessage="Please provide your new password below" />
              </p>
              <div className="general-form-container">
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="reg_password">
                      <FormattedMessage id="password-reset.new-pass" defaultMessage="New Password" />
                    </label>
                    <InputGroup>
                      <input
                        name="reg_password"
                        type="password"
                        autoComplete="new-password"
                        className={
                              classNames(
                                'form-control',
                                { 'form-field-error':
                                  confirmPasswordError || passwordLengthError,
                                },
                              )
                            }
                        onChange={handleChange}
                      />
                    </InputGroup>
                    {passwordLengthError &&
                    <div className="form-helper-text">
                      {passwordLengthError}
                    </div>
                        }
                  </div>

                  <div className="form-group">
                    <label htmlFor="reg_confirm">
                      <FormattedMessage id="password-reset.confirm-password" defaultMessage="Confirm Password" />
                    </label>
                    <InputGroup>
                      <input
                        name="reg_confirm"
                        type="password"
                        autoComplete="new-password"
                        className={
                              classNames(
                                'form-control',
                                { 'form-field-error':
                                  confirmPasswordError && !passwordLengthError,
                                },
                              )
                            }
                        onChange={handleChange}
                      />
                    </InputGroup>
                    {confirmPasswordError && !passwordLengthError &&
                    <div className="form-helper-text">
                      {confirmPasswordError}
                    </div>
                        }
                  </div>

                  {passwordReset?.status !== 0 && passwordReset?.status !== 99 &&
                  <div className="mb-4">
                    <MessageBox
                      type="error"
                      title="Error"
                      message={passwordReset.error}
                    />
                  </div>
                      }
                  <div className="cta-group-container mt-4">
                    <div className="cta-container">
                      <Button
                        type="submit"
                        name="button"
                        color="primary"
                        size="lg"
                        className="login-button"
                      >
                        <FormattedMessage id="password-reset.password-saved" defaultMessage="Save Password" />
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </React.Fragment>
              }

            {passwordReset?.status === 99 &&
            <React.Fragment>
              <h4>
                <FormattedMessage id="password-reset.password-reset" defaultMessage="Your password has been reset" />
              </h4>
              <div className="cta-group-container mt-4">
                <div className="cta-container">
                  <Link to="/" className="btn btn-primary">
                    <FormattedMessage id="password-reset.password-reset.home" defaultMessage="Go to the Homepage" />
                  </Link>
                </div>
              </div>
            </React.Fragment>
              }
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

PasswordReset.propTypes = {
  password_reset: PropTypes.shape({
    error: PropTypes.string,
    status: PropTypes.number,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string,
    }),
  }),
};

PasswordReset.defaultProps = {
  password_reset: {
    error: '',
    status: 0,
  },
  match: ({
    params: {
      token: '',
    },
  }),
};

export default PasswordReset;
